import React, { useCallback } from 'react';

import { useSelectRootContext } from './SelectRootContext';

export const useSelectedOption = () => {
    const { selection, optionLabelProp, rowComponent: RowComponent } = useSelectRootContext();
    const { selectedOption } = selection;

    const renderer = useCallback(() => {
        if (!selectedOption) return null;
        const { original, ...rest } = selectedOption;
        const mergedSelectedOption = {
            ...rest,
            ...original
        };
        if (RowComponent) {
            return <RowComponent key={selectedOption.key} {...mergedSelectedOption} />;
        }
        return optionLabelProp ? mergedSelectedOption[optionLabelProp] : mergedSelectedOption.label;
    }, [RowComponent, optionLabelProp, selectedOption]);

    return {
        option: selectedOption,
        renderer
    };
};
